import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import StatsView from './StatsView';

@inject('commonStore','statsStore')
@observer
class StatsContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.statsStore.setCommonStoreInfo(this.props.commonStore);
    this.props.statsStore.onClear();
    this.props.statsStore.disGoodsList();
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <Fragment>
        <StatsView 
          ceType={sessionLoginInfo?.ceType || "" }
          cGbn={sessionLoginInfo?.cGbn || "" }
        />
      </Fragment>
    );
  }

}

export default withRouter(StatsContainer);
